import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store';
import i18n from './translations';
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-213802525-1',
});

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
